export class Waitlist {
  constructor(form) {
    this.form = form;
    this.sizes = form.querySelectorAll('.pdp-c-waitlist__size-item');
    this.userEmail = form.querySelector('.pdp-c-waitlist__email-input');
    this.userCountry = form.querySelector('.pdp-c-waitlist__country-selector');
    this.termsContent = form.querySelectorAll('.pdp-c-waitlist__terms-content');
    this.errorMessage = document.querySelector('.pdp-c-waitlist__error');
    this.termsMoreBtn = form.querySelector('.pdp-c-waitlist__terms-more-btn');
  }

  init() {
    this.#bindEvents();
  }

  #bindEvents() {
    this.form?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.#validateForm() && this.#sendForm();
    });

    this.sizes.forEach((size) => size.addEventListener('click', this.#handleSizeClick.bind(this, size)));

    this.termsMoreBtn.addEventListener('click', this.#handleMoreBtnClick.bind(this));
  }

  #handleSizeClick(size) {
    size.classList.toggle('pdp-c-waitlist__size-item--selected');
  }

  #handleMoreBtnClick() {
    this.termsContent.forEach(
      (item, index) => index > 0 && item.classList.toggle('pdp-c-waitlist__terms-content--hidden'),
    );
    this.termsMoreBtn.setAttribute('data-open', 'true');
  }

  #showError(message) {
    this.errorMessage.classList.add('is-visible');
    this.errorMessage.textContent = message;
  }

  close() {
    this.form.reset();
    this.sizes.forEach((size) => size.removeEventListener('click', this.#handleSizeClick));
    history.replaceState(null, null, window.location.pathname.replace(/\/\//g, '/') + window.location.search);
  }

  #validateForm() {
    const expression =
      // eslint-disable-next-line no-useless-escape
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const selectedSizes = this.form.querySelectorAll('.pdp-c-waitlist__size-item--selected');
    const emailValue = this.form.email.value;
    const countryValue = this.form.country?.value;
    const errors = [];
    this.#cleanError();
    if (!selectedSizes.length) {
      errors.push('select a size.');
      this.sizes.forEach((size) => size.classList.add('pdp-c-waitlist__size-item--error'));
    }

    if (!emailValue) {
      errors.push('enter your email address.');
      this.userEmail.classList.add('pdp-c-waitlist__email-input--error');
    } else if (!expression.test(String(emailValue).toLowerCase())) {
      errors.push('enter a valid email address.');
      this.userEmail.classList.add('pdp-c-waitlist__email-input--error');
    }

    if (!countryValue) {
      errors.push('select your country.');
      this.userCountry.classList.add('pdp-c-waitlist__country-selector--error');
    }

    if (errors.length) {
      this.#showError('Oops! Please fix the following errors: ' + errors.join(' '));
      return false;
    }

    return true;
  }

  #cleanError() {
    this.sizes.forEach((size) => size.classList.remove('pdp-c-waitlist__size-item--error'));
    this.userEmail.classList.remove('pdp-c-waitlist__email-input--error');
    this.userCountry.classList.remove('pdp-c-waitlist__country-selector--error');
  }

  #setConfirmation(email, selectedSizes) {
    this.form.setAttribute('data-waitlist-status', 'success');
    this.form
      .closest('.pdp-c-waitlist__wrapper')
      .querySelector(
        '.pdp-c-waitlist__subheading',
      ).textContent = `We'll notify you at ${email} when this product becomes available again`;
    this.form.closest('.pdp-c-waitlist__wrapper').querySelector('.pdp-c-waitlist__heading').textContent =
      "You're on the list!";
    this.form
      .closest('.pdp-c-waitlist__wrapper')
      .querySelector(
        '.pdp-c-waitlist__size-confirmation-text-wrapper>.pdp-c-waitlist__size-confirmation-value',
      ).textContent = selectedSizes.join(', ') || 'none';
  }

  /**
   * Sends the waitlist form data to the server
   */
  #sendForm() {
    const email = this.form.email.value;
    const sizes = this.form.querySelectorAll('.pdp-c-waitlist__size-item--selected');
    const skus = [];
    const selectedSizes = [];
    sizes.forEach((size) => {
      skus.push(size.dataset.variantSku);
      selectedSizes.push(size.innerText);
    });

    const domain = window.location.host;
    const url =
      domain === 'www.windsorstore.com'
        ? 'https://shopify-inventory-service.wndsr.io/waitlist'
        : 'https://shopify-inventory-service.wndsr.dev/waitlist';

    const data = {
      contact: email,
      contact_type: 'email',
      skus: skus,
    };

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.text())
      .then((data) => {
        this.#setConfirmation(email, selectedSizes);

        // Defer this block because they are not user-visible tasks
        setTimeout(() => {
          window.dataLayer.push({
            event: 'add_to_waitlist_submit',
            product_name: this.form.dataset.productTitle,
            product_id: this.form.dataset.productId,
          });
          return JSON.stringify(data);
        }, 0);
      })
      .catch(() => {
        console.error('Error in sending request over to waitlist.');
        this.#showError('Error in sending request over to waitlist.');
      });
  }
}
